import { render, staticRenderFns } from "./roster-classlink.vue?vue&type=template&id=4e7545bc&scoped=true&"
import script from "./roster-classlink.ts?vue&type=script&lang=ts&"
export * from "./roster-classlink.ts?vue&type=script&lang=ts&"
import style0 from "./roster-classlink.scss?vue&type=style&index=0&id=4e7545bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7545bc",
  null
  
)

export default component.exports